export const getAllowedValue = function (
  value: number | string,
  minValue: number,
  maxValue: number,
) {
  const intVal = getNumbericValue(value);
  // if (isNaN(intVal)) return '';
  if (intVal < minValue) return minValue;
  if (intVal > maxValue) return maxValue;
  return intVal;
};

const getNumbericValue = (value: number | string) => {
  return typeof value === 'number' ? value : parseInt(value);
};
